import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { mastercard, money, visapayment } from "../Constant/Index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MyModal from "../Components/MyModal";
import Toggle from "../Components/Toggle";
import {
  getSymtoms,
  getSymtomsapi,
  patientBookapointment,
} from "../network/Network";
import { useSelector } from "react-redux";
import StripeForm from "../Components/StripeForm";
import Swal from "sweetalert2";

const BookAppointmentPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const physicianDetail = useSelector((state) => state?.Auth?.physician);
  const token = useSelector((state) => state?.Auth?.token);

  const [selectedCard, setSelectedCard] = useState("");
  const [initialState, setInitialState] = useState(false);
  const [isOn, setIsOn] = useState(initialState);
  const [symptoms, setSymptoms] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedSymptom, setSelectedSymptom] = useState("");
  const [selectdetails, setSelectdetails] = useState("");
  const [formErrors, setFormErrors] = useState([]);

  const { myday, date, selectedTime } = location?.state ?? {};

  const handleCardClick = (card) => {
    setSelectedCard(card);
  };
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Get Symptoms Api
  useEffect(() => {
    getSymtomsapi().then((res) => {
      setSymptoms(res?.data);
    });
  }, []);

  //   Symptom Selected Function
  const handleSelectChange = (event) => {
    setSelectedSymptom(event.target.value);
  };
  //   ================

  //   Stripe css
  const styling = {
    marginTop: "10px",
    width: "100%",
    padding: "8px 16px",
    borderRadius: "20px",
  };

  const PlaceholderHandler = (e, stripe_token) => {
    e.preventDefault();
    let isValid = true;
    const errors = {};

    if (!symptoms) {
      Swal.fire({
        icon: "error",
        text: "select symtoms",
      });
    }

    // Validate Email
    if (!selectdetails) {
      if (!errors || !errors.selectdetails) {
        if (!errors) errors = {};
        errors.selectdetails = [];
      }
      errors.selectdetails.push("Details is required");
      isValid = false;
    }

    setFormErrors(errors);
    setTimeout(() => {
      setFormErrors([]);
    }, 3000);
    let data = {
      booking_day: myday,
      booking_date: date,
      booking_time: selectedTime,
      symptom_id: selectedSymptom,
      detail: selectdetails,
      share_medical_reports: isOn,
      stripe_token: stripe_token,
      physician_id: physicianDetail?.id,
    };

    patientBookapointment(data, token)
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Congratulations!",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/personal-info");
       
      })
      .catch((err) => {});
  };

  return (
    <>
      <Header />
      <PageHeader pagename="Total Amount" />
      <section className="payment-module">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="physician_detail mb-4">
                <div className="row">
                  <h3
                    style={{
                      textDecoration: "underlined",
                    }}
                    className="main-heading-font dark-color level-3 text-start mb-4"
                  >
                    Physician
                  </h3>
                  <div className="col-md-6">
                    <div className="physician_detail_dv">
                      <p>
                        <label className="main-heading-font dark-color ">
                          First Name:
                        </label>{" "}
                        &nbsp;
                        {physicianDetail?.first_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="physician_detail_dv">
                      <p>
                        {" "}
                        <label className="main-heading-font dark-color">
                          Last Name:
                        </label>{" "}
                        &nbsp;
                        {physicianDetail?.last_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="physician_detail_dv">
                      <p>
                        <label className="main-heading-font dark-color ">
                          Degree:
                        </label>{" "}
                        &nbsp;
                        {physicianDetail?.degree_title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h3 className="main-heading-font dark-color level-3 text-start">
                Selected Time And Date
              </h3>
              <form>
                <div className="row">
                  <div>
                    {/* Time input */}

                    {/* Display the selected time */}
                    {selectedTime ? (
                      <div
                        className={`select-hour-bg   ${
                          selectedTime ? "active mt-3" : ""
                        }`}
                      >
                        <h4>{selectedTime}</h4>
                      </div>
                    ) : (
                      <div
                        className={`select-hour-bg mt-3  ${
                          selectedTime ? "active mt-3" : ""
                        }`}
                      >
                        <h4>Select time</h4>
                      </div>
                    )}
                    {myday && date.toString() ? (
                      <>
                        <div
                          className={`select-hour-bg  ${
                            date ? "active mt-3" : ""
                          }`}
                        >
                          <h4>
                            {myday}&nbsp;
                            {date.toString()}
                          </h4>
                        </div>
                      </>
                    ) : (
                      <div
                        className={`select-hour-bg mt-3  ${
                          date ? "active mt-3" : ""
                        }`}
                      >
                        <h4>Select you date </h4>
                      </div>
                    )}
                  </div>
                  {/* <Timecheck /> */}
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <Toggle
                      heading="Share Medical Reports"
                      initialState
                      isOn={isOn}
                      setIsOn={setIsOn}
                      containerClassName="symptoms-container d-flex align-items-center justify-content-between mt-3 border-bottom mb-2 pb-3"
                    />
                  </div>{" "}
                </div>
                <div className="row  mt-3">
                  <div className="form-group col-lg-12">
                    <div className="custom-select-wrapper">
                      <h5 className="main-heading-font dark-color level-6 mb-2">
                        Enter Details
                      </h5>
                      <select
                        className="form-control custom-select"
                        id="symptoms"
                        value={selectedSymptom}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select a symptom</option>
                        {symptoms?.map((item, sindex) => {
                          return (
                            <>
                              <option key={sindex} value={item.id}>
                                {item?.title}
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <h5 className="main-heading-font dark-color level-6 mb-2">
                      Enter Details
                    </h5>
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        id="message"
                        rows="4"
                        value={selectdetails}
                        onChange={(e) => setSelectdetails(e.target.value)}
                        placeholder="Enter Details"
                      />
                      <p className="forms-error">{formErrors?.selectdetails}</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-lg-6">
              <div className="mainpaymnet">
                <h5 className=" main-heading-font">Choose Card</h5>
                <div className="d-flex align-items-start justify-content-between">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={visapayment}
                      className={`img-fluid payment-card ${
                        selectedCard === "visa" ? "selected" : ""
                      }`}
                      alt="Visa"
                      onClick={() => handleCardClick("visa")}
                    />
                    <img
                      src={mastercard}
                      className={`img-fluid payment-card ${
                        selectedCard === "mastercard" ? "selected" : ""
                      }`}
                      alt="Mastercard"
                      onClick={() => handleCardClick("mastercard")}
                    />
                  </div>
                  <div className="payment-wrapper">
                    <h4 className="level-7 text-end">Total Amount</h4>
                    <h3 className="main-heading-font level-3 text-end">
                      $80.00
                    </h3>
                  </div>
                </div>
                <form action="" className="payment-form">
                  <div className="row mt-3">
                    <div className="col-lg-12">
                     
                      <StripeForm
                        styling={styling}
                        paynow="Confirm Order"
                        PaymentHandler={PlaceholderHandler}
                      />
                    </div>
                  </div>
                </form>
                <div className="row">
                  <div className="col-lg-12">
                    <MyModal show={show} handleClose={handleClose} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default BookAppointmentPayment;
